module.exports = __webpack_public_path__ + "static/get_started_mobile-1844073e31cd202a9cad94ba2ef39662.jpg";